import styled from 'styled-components';
import { layout, media } from '@prisjakt/ui-base';
import Button from '@prisjakt/ui-button';
import BaseProductRow from '@prisjakt/ui-product-row';

const productRowHeight = 55;

const FlexWrapper = styled.div`
  display: flex;
  align-items: center;
`;

// Use position: sticky when supported
// otherwise fallback to position: fixed
// and set specific width for desktop viewport size
const Container = styled.div`
  max-height: 70vh;
  display: flex;
  flex-direction: column;
  background-color: white;
  position: fixed;
  bottom: 0;
  z-index: 99;
  width: 100%;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.15);

  ${media.largeUp`
    width: 760px;
  `}

  @supports (position: sticky) {
    position: sticky;
    width: 100%;
  }
`;

const Header = styled.div`
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  background-color: ${p => p.theme.colors.yellove500};
  padding: 10px;
  cursor: pointer;
`;

const ExpandIcon = styled.div`
  margin-right: 10px;

  svg {
    display: block;
  }
`;

const CompareButton = styled(Button)`
  background-color: white;
  padding: 5px 10px;
`;

const ClearButton = styled(Button)`
  padding: 5px;
`;

const ProductDeleteButton = styled(Button)``;

const InfoBar = styled.div`
  width: 100%;
  text-align: center;
  border-bottom: 1px solid ${p => p.theme.colors.base200};
  padding: 5px 10px;
`;

const InfoText = styled.div`
  font-size: 12px;
  font-style: italic;
  color: ${p => p.theme.colors.base600};
`;

const ProductCount = styled.div`
  font-size: 12px;
  font-weight: 600;
`;

type ProductWrapperProps = { expanded?: boolean; count: number };
const ProductWrapper = styled.div<ProductWrapperProps>`
  width: 100%;
  padding: 0 ${layout.spacing.xSmall};
  padding-bottom: ${props => (props.expanded ? layout.spacing.small : 0)};
  box-sizing: border-box;
  transition: max-height 0.15s
    ${props => (props.expanded ? 'ease-out' : 'ease-in')};
  overflow: hidden;
  overflow-y: auto;
  max-height: ${props =>
    props.expanded ? props.count * productRowHeight + productRowHeight : 0}px;
`;

const ProductRow = styled(BaseProductRow)`
  && {
    min-height: unset;
  }
`;

export {
  FlexWrapper,
  Container,
  Header,
  ExpandIcon,
  CompareButton,
  ClearButton,
  ProductDeleteButton,
  InfoBar,
  InfoText,
  ProductCount,
  ProductWrapper,
  ProductRow,
};
